import PocketBase from 'pocketbase';

export const CollectionNames = {
  USERS: 'users',
  RESIDENCES: 'residences',
  EXCHANGE_INTENTIONS: 'exchange_intentions',
  CONFIRMED_EXCHANGES: 'confirmed_exchanges',
  CHATS: 'chats',
  CHAT_MESSAGES: 'chat_messages',
  RATINGS: 'user_ratings',
  CONTACT_MESSAGES: 'contact_messages',
};

export class PocketBaseService {
  private static instance: PocketBaseService | null = null;
  private pb: PocketBase;

  private constructor() {
    const baseUrl = import.meta.env.VITE_BACKEND_URL || 'http://127.0.0.1:8090';
    this.pb = new PocketBase(baseUrl);
  }

  public static getInstance(): PocketBaseService {
    if (!PocketBaseService.instance) {
      PocketBaseService.instance = new PocketBaseService();
    }
    return PocketBaseService.instance;
  }

  public getPocketBase(): PocketBase {
    return this.pb;
  }
}
